import GraphRanges from "@/mixins/GraphRanges";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";

@Component({})
export default class Hem extends mixins(GraphRanges) {
  @Getter("graph", patientNamespace)
  graph!: any;

  @Getter("config", patientNamespace)
  config!: any;

  @Getter("current", patientNamespace)
  current!: Patient;

  get charts(): MultiChartConfig[] {
    const chartList: MultiChartConfig[] = [];

    if (this.hemData.length) {
      chartList.push({
        title: this.labels.join(" & "),
        data: this.hemData,
        library: this.chartConfig
      });
    }

    return chartList;
  }

  get hemData() {
    return this.graph(
      [
        { key: "HCT", label: "HCT", yAxisID: "Left" },
        { key: "HGB", label: "HGB", yAxisID: "Right" }
      ],
      true
    );
  }

  get labels() {
    const labels: Array<string> = [];
    this.hemData.forEach((d: any) => {
      labels.push(d.label);
    });
    return labels;
  }

  get chartConfig() {
    const hctScale = {
      id: "Left",
      position: "left",
      type: "linear",
      ticks: {
        max: 60,
        min: 0,
        stepSize: 15
      }
    };

    const hgbScale = {
      id: "Right",
      position: "right",
      type: "linear",
      ticks: {
        max: 20,
        min: 0,
        stepSize: 5
      }
    };
    const yAxes: Array<any> = [];

    this.labels.forEach((label: string) => {
      switch (label) {
        case "HCT":
          yAxes.push(hctScale);
          break;
        case "HGB":
          yAxes.push(hgbScale);
          break;
      }
    });

    return {
      scales: {
        yAxes
      }
    };
  }
}
